import React from 'react';

export const ModalLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <div className="w-8 h-8 flex items-center justify-center">
    <svg
      {...props}
      viewBox="0 0 150 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <rect
        x="13.8"
        y="13.27"
        width="124.41"
        height="124.41"
        fill="currentColor"
      />
      <g clipPath="url(#modal-clip)">
        <path
          d="M47.81,50.52h19.65l9.6,16.91-18.81,33.03h-19.65l-9.82-17.12,19.03-32.82Zm.8,4.27l-16.56,28.56,7.36,12.84,16.38-28.75-7.17-12.64Zm9.63,14.06l-16.39,28.77h14.74l16.39-28.77h-14.74Zm14.74-2.84h-14.74l-7.18-12.65h14.74l7.18,12.65Z"
          fill="#7fee64"
          fillRule="evenodd"
        />
        <path
          d="M122.17,83.55l-9.82,17.01-19.44-.14-19.2-32.8,9.83-17.02,19.74,.06,18.9,32.89Zm-4.1-1.44l-16.45-28.62-14.8-.04,16.71,28.56,14.53,.11Zm-16.99,1.31l-16.72-28.58-7.37,12.76,16.72,28.58,7.37-12.76Zm-4.91,14.19l7.37-12.77,14.55,.11-7.37,12.77-14.55-.11Z"
          fill="#7fee64"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="modal-clip">
          <rect x="28.31" y="49.45" width="93.72" height="52.07" />
        </clipPath>
      </defs>
    </svg>
  </div>
);
